import { remoteLabs } from 'constants/remoteLabs'
import { customLayoutKeys } from 'redesign/constants/customLayout'

/* eslint-disable max-len */
export const defaultConfig = {
    booleans: {
        AUTH_SHOW_LAB_LOGO: true,
        AUTH_LOAD_REPORTS_HISTORY: false,
        AUTH_NEW_REDIRECT_FLOW: false,
        AUTH_LIMITED_FLOW_ONLY: true,
        AUTH_SERVICE_DOWN: false,
        AUTH_PASSWORD_SIMPLIFICATION: true,
        AUTH_ENABLE_LOGIN_OTP: false,
        AUTH_ENABLE_UNICO: false,
        AUTH_ENABLE_FEDERAL_REVENUE_CHECK: false,
        AUTH_KEEP_LOGGED: false,
        AUTH_ENABLE_MAGIC_LINK: false,
    },

    jsons: {
        NAV_PHASED_LOGIN: JSON.stringify({ visibility: true, nav_pro_url: 'https://pro-nav.dasa.com.br/auth' }),
        AUTH_LAB_DATA: JSON.stringify(remoteLabs),
        AUTH_LAB_DATA_LAVOISIER: JSON.stringify(remoteLabs.laboratories.lavoisier),
        AUTH_LAB_DATA_DELBONI: JSON.stringify(remoteLabs.laboratories.delboni),
        AUTH_CUSTOM_LAYOUTS: JSON.stringify({
            domiciliar: {
                paramKey: 'acesso',
                layout: customLayoutKeys.mobileService,
                loginPage: customLayoutKeys.mobileService,
                title: 'Identifique-se para continuar seu agendamento',
                description: 'Para iniciar, insira o CPF do paciente. Caso seja menor de idade, preencha com o CPF do responsável:',
            },
        }),
        AUTH_ALLOWED_DOMAINS: JSON.stringify(['https://nav.dasa.com.br/', 'https://dasa.com.br/', 'https://cadastro.uat.unico.app/']),
    },

    strings: {
        AUTH_REDIRECT_LOGIN: '/plataforma/inicio',
        AUTH_REDIRECT_LOGIN_LIMITED_FLOW: '/plataforma/exames/limitado',
        NAV_NAC_NUMBER: '4020-2117',
    },

    numbers: {},
}

export type FeatureFlagsKeys = keyof typeof defaultConfig.booleans

export type DefaultConfig = typeof defaultConfig
